import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=2acaad02&scoped=true"
import script from "./NewsPage.vue?vue&type=script&lang=ts"
export * from "./NewsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acaad02",
  null
  
)

export default component.exports